import { useState, useEffect, useCallback } from 'react';

interface AsyncResource<T> {
  data: T;
  loading: boolean;
  error: string | null;
  reload: () => void;
}

export function useAsyncResource<T>(
  fetcher: () => Promise<T>,
  initial: T,
): AsyncResource<T> {
  const [data, setData] = useState<T>(initial);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback((): void => {
    setLoading(true);
    setError(null);
    fetcher()
      .then(setData)
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  }, [fetcher]);

  useEffect(reload, [reload]);

  return { data, loading, error, reload };
}
